<!-- Contenido Secundario -->
<div class="opportunity-content">
  <div class="main-content-inner">
    

    <!-- Tabs -->
    <nz-tabset *ngIf="afterViewInit"
               (nzSelectedIndexChange)="closeAllDrawers()"
               [ngClass]="[padding ? 'padding' : '', overflowAuto ? 'overflow-auto' : '']">
      @for (tab of tabs; track tab.name) {
        <nz-tab [nzTitle]="titleTemplate" style=" height: 800px !important;
   overflow: hidden !important">
          <ng-template #titleTemplate>
            <app-st-icon style="margin-right: 5px ;" [name]="tab.icon"></app-st-icon>
            {{ tab.name }}
          </ng-template>

          <!-- Contenido de la pestaña -->
          <ng-container *ngTemplateOutlet="tab.tmpl"></ng-container>
        </nz-tab>
      }
    </nz-tabset>
  </div>
</div>


<!--Equipment-->
<ng-template #equipmentTmpl>
  <div class="tab-content gap-200">
<!--    <h3 *ngIf="!isDrawer" class="text-header-24">Equipos</h3>-->
    <div *ngIf="!loadingEquipments" style="flex-grow: 1">
      @if (currentEquipments && currentEquipments.length > 0) {
        <app-equipment-table [equipments]="currentEquipments"
                             [disableAsignEquipments]="!authService.loggedUser$.value?.editSOUnlimited"
                             (equipmentsChanged)="onEquipmentsChanged($event)"></app-equipment-table>
      } @else {
        <app-empty-state (btnPressEvent)="openAsignEquipmentDrawer()" [icon]="'warehouse'"
                         [hideBtn]="!authService.loggedUser$.value?.editSOUnlimited"
                         [object]="'equipos'" [btnIcon]="'add'" [btnText]="'Asignar equipos'"
                         [text]="'Haz click en el botón más abajo para asignar el primero'"></app-empty-state>
      }
    </div>
    <nz-skeleton *ngIf="loadingEquipments" [nzActive]="true" [nzParagraph]="{rows: 6}"></nz-skeleton>
  </div>
</ng-template>

<!--Docs-->
<ng-template #docsTmpl>
  <div class="tab-content gap-200">
<!--    <h3 *ngIf="!(isMobile$ | async)" class="text-header-24">Documentos</h3>-->

    <app-doc-section
      [entityType]="'Service'"
      [entityId]="service.id"
      [documents]="service.documents || []"
      (isDocDrawerOpen)="sendIsDocDrawerOpen($event)"
    ></app-doc-section>
  </div>
</ng-template>

<!--Orders-->
<ng-template #ordersTmpl>
  <!--  Table  -->
  
  <div class="status-column-highlight">
    <app-layout-maestro
      [maestroName]="'Subtareas'"
      [tableData]="serviceOrders"
      [columnsData]="serviceOrderColumnsData"
      [formColumnsData]="serviceOrderFormColumnsData"
      [hideHeader]="true"
      [createButtonText]="'Añadir subtarea'"
      [showCheckboxes]="true"
      [customDrawer]="{ detailsComponent: serviceOrderDetailsDrawerComponent, detailsComponentWidth: '100%' }"
      (createEvent)="createServiceOrder($event)"
      (updateEvent)="updateServiceOrder($event)"
      (deleteEvent)="deleteServiceOrder($event)"
      (deleteMultipleEvent)="deleteMultipleServiceOrders($event)"
    (creationCompleted)="onCreationCompleted()"
    (deletionCompleted)="onDeletionCompleted()">
    </app-layout-maestro>
  </div>
</ng-template>

<!--Inbox-->
<ng-template #inboxTmpl>
  <div class="tab-content gap-200">
    <h3 class="text-header-24">Inbox</h3>
  </div>
</ng-template>

<!--Tariff-->
<ng-template #tariffTmpl>
  <div class="tab-content gap-200">
    <h3 class="text-header-24">Tarifas</h3>
  </div>
</ng-template>

<!--Detail-->
<ng-template #detailTmpl>
  <app-list-key-value [data]="setDetailKaeyValueItems()"
                      [keysWidth]="{value: (isMobile$ | async) ? 132 : 160, unit: 'px'}"
                      [innerColumnGap]="{value: 6, unit: 'px'}"
                      [innerRowGap]="{value: 6, unit: 'px'}"
                      [outterColumns]="(isMobile$ | async) ? 1 : 2"
                      [outterColumnGap]="{value: 32, unit: 'px'}"
                      class="detail-list-key"
  ></app-list-key-value>
</ng-template>

<!--Flujo-->
<ng-template #flowTmpl>
  <div class="tab-content gap-200">
<!--    <h3 *ngIf="!(isMobile$ | async)" class="text-header-24">Flujo</h3>-->

    <app-flow-section></app-flow-section>
  </div>
</ng-template>

<ng-template #notificationTmpl>
  <app-toast *ngIf="notRef" [icon]="toastConfig.icon" [iconColor]="toastConfig.iconColor"
    [showUndo]="toastConfig.showUndo" [notRef]="notRef" [content]="toastConfig.content"
    [msg]="toastConfig.msg"></app-toast>
</ng-template>
